<template>
  <div>
    <div class="listing-container" :class="this.forsalepage ? 'forsale-page' : '' ">
      <div class="my-2" v-if="hasPagination">
        <pagination :current="parseInt(currentPage)" :pagerange=-1 :total="filteredItems.length" :perpage="parseInt(postsperpage)" @page-changed="currentPage = $event"/>
      </div>
      <div>
        <div v-if="this.view === 'list'" class="d-flex flex-wrap">
          <template v-if="index <= itemsToShow" v-for="(item, index) in visibleItems">
            <listingcard :item="item" :columns="columns" :class="wrapperClass"></listingcard>

            <div v-if="(index === Object.keys(visibleItems).length - 1) && ((Object.keys(visibleItems).length - 1) % 2 === 0) && uspsArray[0] && realtor > 0" :class="wrapperClass">
              <usp :uspItem="uspsArray[0]"></usp>
            </div>
          </template>
        </div>
        <div v-if="this.view === 'map'">
          <viewmap :items="visibleItems"></viewmap>
        </div>
        <div v-if="this.view === 'list'">
          <div v-if="itemsToShow <= visibleItems.length" class="load-more-wrapper w-100 d-flex justify-content-center pb-3 pb-md-5">
            <button @click="itemsToShow += 10" class="link__background">Visa fler objekt</button>
          </div>
        </div>
      </div>
      <div class="col-12 mt-2 mb-4" v-if="hasPagination">
        <pagination :current="parseInt(currentPage)" :pagerange=-1 :total="filteredItems.length" :perpage="parseInt(postsperpage)" @page-changed="currentPage = $event"/>
      </div>
    </div>
    <span v-if="mutableLink" class="w-100 link-wrapper d-flex justify-content-center mt-md-5"><a :href="mutableLink.url" class="link__background white medium d-block d-md-inline-block">{{ mutableLink.title }}</a></span>
    <h2 v-if="filteredItems.length === 0" class="text-center mb-4" v-html="placeholder"></h2>
  </div>
</template>
<script>
import listingcard from './listingcard';
import pagination from './pagination';
import viewmap from "./viewmap";

export default {
  components: {
    listingcard,
    pagination,
    viewmap,
  },
  props: {
    link: {
      default: false,
    },
    type: {
      default: 'all',
    },
    office: {
      default: 'all',
    },
    title: {
      default: '',
    },
    count: {
      default: 3,
    },
    sold: {
      default: 0,
    },
    minilist: {
      default: 0,
    },
    showcontact: {
      default: false,
    },
    realtor: {
      default: -1,
    },
    assistingrealtor: {
      default: -1,
    },
    postsperpage: {
      default: -1,
    },
    forsalepage: {
      default: 0,
    },
    usps: {
      type: String,
      default: ''
    },
    columns: {
      default: 2,
    },
    upcoming: {
      default: -1,
    },
    newproduction: {
      default: -1,
    },
    itemstoshow: {
      default: false,
    },
    placeholder: {
      default: 'Det finns inga objekt här, prova en annan sökning.',
    }
  },
  data: function() {
    return {
      originalItems: [],
      filteredItems: [],
      filename: 'listings',
      mutableLink: this.link ? JSON.parse(this.link) : false,
      currentPage: 1,
      filterValues: [],
      currentSort: {
        sort: 'firstPublished',
        order: 'desc',
      },
      searchInput: '',
      uspsArray: [],
      itemsToShow: this.itemstoshow ? 9 : 200,
      view: 'list',
      items: [],
      objectTypeExists: false,
    };
  },
  computed: {
    visibleItems: function() {
      const skipCount = this.postsperpage > 0 ? (this.postsperpage * (this.currentPage - 1)) : 0;
      const takeCount = this.postsperpage > 0 ? this.postsperpage : this.filteredItems.length;
      return _.take(_.drop(this.filteredItems, skipCount), takeCount);
    },
    hasPagination: function() {
      return this.postsperpage > 0;
    },
    wrapperClass: function() {
      return parseInt(this.columns) === 2 ? 'listing-wrapper column-lg-6 mb-3 two-cols' : 'listing-wrapper column-lg-12 mb-3';
    },
  },
  methods: {
    listingsFilter: function(filterValues) {
      //update filterValues with emitted values
      this.filterValues = filterValues;
      //filter it
      this.performFilter();
    },
    listingsView: function(view) {
      this.view = view;
    },
    performFilter: function() {
      const filterValues = this.filterValues;
      const objectTypes = [];
      const objectAreas = [];
      this.filteredItems = this.originalItems; //reset

      // Filter listings by address, district, city and realtor.
      if (filterValues.search) {
        let field = filterValues.search.toLowerCase().replace(/\s+/g, ' ').trim();

        this.filteredItems = _.filter(this.filteredItems, function(item) {
          if ((item.address.toLowerCase().indexOf(field)>-1) || (item.commune.toLowerCase().indexOf(field)>-1) || (item.city.toLowerCase().indexOf(field)>-1) || (item.realtor.name.toLowerCase().indexOf(field)>-1)) {
            return item;
          }
        });

        // Send event to listingsfilter, to be able to check if filteredItems are empty.
        Event.fire('listings-no-items', this.filteredItems.length);
      }

      //filter on object types
      if (filterValues.object_type) {
        filterValues.object_type.forEach((item) => {
          objectTypes.push(item.value);
        });
        if (objectTypes.length) {
          this.filteredItems = _.filter(this.filteredItems, function(item) {
            if (objectTypes.includes('all') || objectTypes.some(r => item.filter.object_type.includes(r))) {
              return item;
            }
          });
        }
      }

      //filter on object area
      if (filterValues.object_area) {
        filterValues.object_area.forEach((item) => {
          objectAreas.push(item.value);
        });
        if (objectAreas.length) {
          this.filteredItems = _.filter(this.filteredItems, function(item) {
            //check if area is "all" or if item.area contains any of the area
            if (objectAreas.includes('all') || objectAreas.some(r => item.filter.object_area.includes(r))) {
              return item;
            }
          });
        }
      }
    },
  },

  mounted: function() {
    const component = this;
    if (component.usps.length > 0) {
      this.uspsArray = JSON.parse(component.usps);
    }

    fetch(prekApiSettings.uploads_path + '/' + this.filename + prekApiSettings._fasad_lastsync + '.json', {}).then((response) => {
      return response.json();
    }).then((data) => {
      let numberOfItems = 0;
      this.originalItems = _.filter(data, function(item) {
        if (
          (item.sold == component.sold || parseInt(component.newproduction) === 1) &&
          (component.upcoming == -1 || parseInt(item.upcoming) == parseInt(component.upcoming)) &&
          ((component.newproduction == -1 && !item.newproduction) || parseInt(item.newproduction) == parseInt(component.newproduction)) &&
          (component.count == -1 || (numberOfItems < component.count)) &&
          (component.type == 'all' || item.type === component.type)
        ) {
          numberOfItems++;
          return item;
        }
      });

      this.originalItems.sort((a, b) => (a.sold > b.sold) ? 1 : (a.sold === b.sold) ? ((a.sortPublished < b.sortPublished) ? 1 : -1) : -1 );
      Event.fire('listings-initial-items', this.originalItems);

      const rootElement = this.$root.$el;
      if (numberOfItems > 0 && rootElement.classList.contains('pre-init')) {
        rootElement.classList.remove('pre-init');
      }
      this.performFilter();
    });
    Event.listen('listings-filter', (filterValues) => {
      //listings-filter event caught
      this.listingsFilter(filterValues)
    });

    Event.listen('listings-view', (view) => {
      //listings-view event caught
      this.listingsView(view)
    });

    //this.view
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('view') === 'map') {
      this.view = urlParams.get('view');
    }
  },
  created() {
  },

};
</script>
<style scoped>

</style>
